import { Devices, DeviceMobile, DeviceTabletSpeaker, Monitor } from "@phosphor-icons/react";
import { SectionShell } from "../Primitives";
import { BREAKPOINTS } from "@/data/designTokens";

export function ResponsiveSection() {
  return (
    <SectionShell
      id="responsive"
      eyebrow="Responsive"
      eyebrowIcon={Devices}
      title="Mobile-first, comfortable everywhere"
      description="Design starts on the smallest screen and grows up. Layouts reflow from a single calm column on phones to a sidebar-and-content canvas on desktop — touch targets stay large at every size."
    >
      <div className="overflow-hidden rounded-3xl border border-border bg-card shadow-soft">
        <div className="hidden grid-cols-4 gap-4 border-b border-border bg-muted/40 px-6 py-4 text-sm font-bold uppercase tracking-wider text-muted-foreground sm:grid">
          <span>Token</span>
          <span>Range</span>
          <span>Device</span>
          <span>Layout</span>
        </div>
        {BREAKPOINTS.map((b, i) => (
          <div
            key={b.token}
            className={`grid grid-cols-2 gap-2 px-6 py-4 sm:grid-cols-4 sm:gap-4 ${i !== 0 ? "border-t border-border" : ""}`}
          >
            <span className="font-display font-extrabold text-primary-strong">{b.token}</span>
            <span className="font-semibold text-foreground">{b.range}</span>
            <span className="font-medium text-muted-foreground">{b.device}</span>
            <span className="font-medium text-muted-foreground">{b.cols}</span>
          </div>
        ))}
      </div>

      <div className="mt-6 grid items-end gap-4 sm:grid-cols-3">
        {[
          { icon: DeviceMobile, t: "Phone", w: "w-24 h-44", note: "One calm column" },
          { icon: DeviceTabletSpeaker, t: "Tablet", w: "w-44 h-44", note: "Two columns + rail" },
          { icon: Monitor, t: "Desktop", w: "w-full h-44", note: "Sidebar + content" },
        ].map(({ icon: Icon, t, w, note }) => (
          <div key={t} className="flex flex-col items-center">
            <div className={`${w} flex items-center justify-center rounded-3xl border-2 border-border bg-gradient-to-b from-accent/60 to-card text-primary shadow-soft`}>
              <Icon size={40} weight="bold" />
            </div>
            <p className="mt-3 font-display font-extrabold">{t}</p>
            <p className="text-sm font-semibold text-muted-foreground">{note}</p>
          </div>
        ))}
      </div>
    </SectionShell>
  );
}

export default ResponsiveSection;
